// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-fields_App__rEHcE {
    width: 100%;
    height: 100%;
    overflow: auto;
    padding-bottom: 20px;
}

.tournament-fields_TournamentsCreationForm__wWQrb{
    background-color: white;
    display: grid;
    grid-template-columns: 6fr;
}

.tournament-fields_InputFields__CxVRl {
    margin-top: 30px!important;
    margin-right: 10px!important;
    margin-left: 10px!important;
}
.tournament-fields_CountryCityRow__MlAdq{
    display: flex;
    justify-content: start;
}
.tournament-fields_CountryCityRow__MlAdq > * {
    width: 100px;
}
.tournament-fields_WeightHeightRow__bqLwC{
    display: flex;
    justify-content: space-between;
}
.tournament-fields_WeightHeightRow__bqLwC > * {
    width: 300px;
}

.tournament-fields_SelectorWrapper__3zCRa{
    margin-top: 30px!important;
    margin-right: 10px!important;
    margin-left: 10px!important;
}

.tournament-fields_FieldRow__gn3rE{
    display: flex;
}

.tournament-fields_DateDivider__mvQgB{
    display: flex;
    justify-content: center;
    align-items: center;
}
.tournament-fields_Selectors__jqrZH {
    display: grid;
    grid-template-columns: 170px 170px 170px 170px;
}
.tournament-fields_CountryISOWithWonTypeRow__g4q5c{
    display: grid;
    grid-template-columns: 220px 220px 220px;
}

@media (max-width: 768px) {
    .tournament-fields_TournamentsCreationForm__wWQrb {
        width: 100vw;
        overflow: auto;
        display: flex;
        flex-direction: column;
    }
    .tournament-fields_FieldRow__gn3rE {
        display: flex;
        flex-direction: column;
    }
    .tournament-fields_Selectors__jqrZH {
        display: flex;
        flex-direction: column;
    }
    .tournament-fields_CountryISOWithWonTypeRow__g4q5c {
        display: flex;
        flex-direction: column;
    }
    .tournament-fields_WeightHeightRow__bqLwC > * {
        width: 100%;
    }
    .tournament-fields_SelectorWrapper__3zCRa{
        >div {
            width: 100%;
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/TournamentsPageN/ui/tournament-fields.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8CAA8C;AAClD;AACA;IACI,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI;QACI,YAAY;QACZ,cAAc;QACd,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI;YACI,WAAW;QACf;IACJ;AACJ","sourcesContent":[".App {\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    padding-bottom: 20px;\n}\n\n.TournamentsCreationForm{\n    background-color: white;\n    display: grid;\n    grid-template-columns: 6fr;\n}\n\n.InputFields {\n    margin-top: 30px!important;\n    margin-right: 10px!important;\n    margin-left: 10px!important;\n}\n.CountryCityRow{\n    display: flex;\n    justify-content: start;\n}\n.CountryCityRow > * {\n    width: 100px;\n}\n.WeightHeightRow{\n    display: flex;\n    justify-content: space-between;\n}\n.WeightHeightRow > * {\n    width: 300px;\n}\n\n.SelectorWrapper{\n    margin-top: 30px!important;\n    margin-right: 10px!important;\n    margin-left: 10px!important;\n}\n\n.FieldRow{\n    display: flex;\n}\n\n.DateDivider{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.Selectors {\n    display: grid;\n    grid-template-columns: 170px 170px 170px 170px;\n}\n.CountryISOWithWonTypeRow{\n    display: grid;\n    grid-template-columns: 220px 220px 220px;\n}\n\n@media (max-width: 768px) {\n    .TournamentsCreationForm {\n        width: 100vw;\n        overflow: auto;\n        display: flex;\n        flex-direction: column;\n    }\n    .FieldRow {\n        display: flex;\n        flex-direction: column;\n    }\n    .Selectors {\n        display: flex;\n        flex-direction: column;\n    }\n    .CountryISOWithWonTypeRow {\n        display: flex;\n        flex-direction: column;\n    }\n    .WeightHeightRow > * {\n        width: 100%;\n    }\n    .SelectorWrapper{\n        >div {\n            width: 100%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `tournament-fields_App__rEHcE`,
	"TournamentsCreationForm": `tournament-fields_TournamentsCreationForm__wWQrb`,
	"InputFields": `tournament-fields_InputFields__CxVRl`,
	"CountryCityRow": `tournament-fields_CountryCityRow__MlAdq`,
	"WeightHeightRow": `tournament-fields_WeightHeightRow__bqLwC`,
	"SelectorWrapper": `tournament-fields_SelectorWrapper__3zCRa`,
	"FieldRow": `tournament-fields_FieldRow__gn3rE`,
	"DateDivider": `tournament-fields_DateDivider__mvQgB`,
	"Selectors": `tournament-fields_Selectors__jqrZH`,
	"CountryISOWithWonTypeRow": `tournament-fields_CountryISOWithWonTypeRow__g4q5c`
};
export default ___CSS_LOADER_EXPORT___;
